import { IncubatorModels } from '@eppendorf/app-configs';

/**
 * Map of device model → parameter subjects whose setpoints cannot be changed
 * through the application. These parameters display a static (read-only)
 * Value + Set point view instead of the interactive threshold form.
 *
 * To add a new device/parameter combination, add an entry to this map.
 */
const STATIC_SETPOINT_PARAMETERS = new Map<string, Set<string>>([
  [IncubatorModels.CELL_XPERT_CS220, new Set(['Agitation'])],
]);

export function hasStaticSetpointDisplay(
  device?: { model?: string } | null,
  telemetryId?: string,
): boolean {
  if (!device?.model || !telemetryId) return false;
  const params = STATIC_SETPOINT_PARAMETERS.get(device.model);
  return !!params && params.has(telemetryId);
}
